import { render, staticRenderFns } from "./VuetifyMoney.vue?vue&type=template&id=1906e508&scoped=true"
import script from "./VuetifyMoney.vue?vue&type=script&lang=js"
export * from "./VuetifyMoney.vue?vue&type=script&lang=js"
import style0 from "./VuetifyMoney.vue?vue&type=style&index=0&id=1906e508&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1906e508",
  null
  
)

export default component.exports